// nivelDestaque
//
// Cálculo do "nível de destaque" da loja na tela de Marketing.
// O nível é a proporção de ações de marketing ativadas (cupons + promoções)
// sobre o total de ações disponíveis (ativadas + prévias ainda não ativadas).
//
// API:
//   NIVEIS
//   calcularNivelDestaque({ acoesAtivas, acoesTotais })

export const NIVEIS = [
  { key: 'bronze', nome: 'Bronze',      emoji: '🥉', min: 0 },
  { key: 'prata',  nome: 'Prata',       emoji: '🥈', min: 30 },
  { key: 'ouro',   nome: 'Ouro',        emoji: '🥇', min: 70 },
  { key: 'super',  nome: 'Super Bigou', emoji: '💎', min: 100 },
];

export function calcularNivelDestaque({ acoesAtivas, acoesTotais }) {
  const ativas = Math.max(0, Number(acoesAtivas) || 0);
  const totais = Math.max(0, Number(acoesTotais) || 0);

  let percentual = 0;
  if (totais > 0) {
    if (ativas >= totais) {
      // 100% (Estrela Bigou) somente quando tudo está ativo — nunca por arredondamento.
      percentual = 100;
    } else {
      percentual = Math.min(99, Math.round((ativas / totais) * 100));
    }
  }

  let nivel = NIVEIS[0];
  NIVEIS.forEach(n => {
    if (percentual >= n.min) nivel = n;
  });

  const idx = NIVEIS.indexOf(nivel);
  const proximoNivel = idx < NIVEIS.length - 1 ? NIVEIS[idx + 1] : null;

  let acoesParaProximoNivel = 0;
  if (proximoNivel && totais > 0) {
    const necessarias = proximoNivel.min === 100
      ? totais
      : Math.ceil((proximoNivel.min / 100) * totais);
    acoesParaProximoNivel = Math.max(1, necessarias - ativas);
  }

  return {
    percentual,
    nivel,
    proximoNivel,
    acoesParaProximoNivel,
    acoesAtivas: ativas,
    acoesTotais: totais,
  };
}

export default {
  NIVEIS,
  calcularNivelDestaque,
};
